import { FC, ReactElement, useContext } from 'react';
import { IRouteComponentProps } from 'umi';
import { useIntl } from 'react-intl';
import { Typography, Button } from 'iglooform';
import { SuccessFilled } from 'iglooicon';
import styles from './index.less';
import Context from '@/utils/context';
import { images } from '@/assets/images';

const ResultPage: FC<IRouteComponentProps> = (): ReactElement => {
  const { search, hostname } = window.location;
  const { isPc } = useContext(Context);
  const { formatMessage } = useIntl();
  return (
    <div className={styles.contents}>
      <img
        className={styles.onboardingBanner}
        src={isPc ? images.onboarding_banner : images.onboarding_banner_h5}
        alt=""
      />
      <SuccessFilled className={styles.icon} style={{ color: '#2ED573' }} />
      <Typography level="h2" wrapElement="div" className={styles.title}>
        {formatMessage({ id: 'Registration Completed!' })}
      </Typography>
      <div className={styles.messageBar}>
        <Typography level="h4" wrapElement="div">
          {formatMessage({ id: 'Please Note:' })}
        </Typography>
        <Typography level="body1" wrapElement="div">
          *{' '}
          {formatMessage({
            id: "IgLoo's Agency Development Department will notify you of the results as soon as your application is approved.",
          })}
        </Typography>
        <Typography level="body1" wrapElement="div">
          **{' '}
          {formatMessage({ id: 'When you need to contact us, please email: ' })}
          <a>ips.vietnam@iglooinsure.com</a>
        </Typography>
      </div>
      <a
        href={
          search.split('=')[1] === '2'
            ? 'https://igniteback'
            : hostname.includes('ignite-vn')
            ? LOGIN_VN_URL
            : LOGIN_URL
        }
      >
        <Button type="primary" style={{ marginBottom: '100px' }}>
          {formatMessage({
            id: 'Get Started',
          })}
        </Button>
      </a>
    </div>
  );
};

export default ResultPage;
